import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  jobs: [],
  loaded: false,
};

const coreSeqJobsSlice = createSlice({
  name: 'coreSeqJobs',
  initialState,
  reducers: {
    setCoreSeqJobs: (state, action) => {
      state.jobs = action.payload || [];
      state.loaded = true;
    },
    resetCoreSeqJobs: () => initialState,
  },
});

export const { setCoreSeqJobs, resetCoreSeqJobs } = coreSeqJobsSlice.actions;

export const selectCoreSeqJobs = (state) => state.coreSeqJobs.jobs;
export const selectCoreSeqJobById = (jobId) => (state) =>
  state.coreSeqJobs.jobs.find((job) => job.id === jobId) || null;

export default coreSeqJobsSlice.reducer;
